export const PLAN_CATALOG = {
    starter: {
        tier: 'starter',
        name: 'Starter',
        monthlyPriceNgn: 5000,
        quarterlyPriceNgn: 14250,
        yearlyPriceNgn: 50000,
        includedAiReplies: 1000,
        channels: { hostedLink: true, whatsapp: true, webWidget: false, social: false },
        available: true,
    },
    growth: {
        tier: 'growth',
        name: 'Growth',
        monthlyPriceNgn: 10000,
        quarterlyPriceNgn: 28500,
        yearlyPriceNgn: 100000,
        includedAiReplies: 5000,
        channels: { hostedLink: true, whatsapp: true, webWidget: true, social: false },
        available: true,
    },
    scale: {
        tier: 'scale',
        name: 'Scale',
        monthlyPriceNgn: 20000,
        quarterlyPriceNgn: 57000,
        yearlyPriceNgn: 200000,
        includedAiReplies: 20000,
        channels: { hostedLink: true, whatsapp: true, webWidget: true, social: true },
        available: false,
    },
};
export const PLAN_SORT_ORDER = ['starter', 'growth', 'scale'];
export function includedAiReplies(planTier) {
    return PLAN_CATALOG[planTier]?.includedAiReplies ?? PLAN_CATALOG.starter.includedAiReplies;
}
export function channelEnabled(planTier, channel) {
    return PLAN_CATALOG[planTier]?.channels[channel] ?? false;
}
export function isPlanAvailable(planTier) {
    return PLAN_CATALOG[planTier]?.available ?? false;
}
export function planPrice(planTier, interval) {
    const plan = PLAN_CATALOG[planTier];
    if (!plan)
        return 0;
    switch (interval) {
        case 'yearly': return plan.yearlyPriceNgn;
        case 'quarterly': return plan.quarterlyPriceNgn;
        default: return plan.monthlyPriceNgn;
    }
}
export function planPriceInKobo(planTier, interval) {
    return planPrice(planTier, interval) * 100;
}
export function formatPlanPrice(tier, interval) {
    const price = planPrice(tier, interval);
    if (price >= 1000) {
        return `₦${(price / 1000).toFixed(price % 1000 === 0 ? 0 : 1)}k`;
    }
    return `₦${price}`;
}
/** Legacy conversation limits mapped to AI replies for migration compatibility. */
export const PLAN_CONVERSATION_LIMITS = {
    starter: PLAN_CATALOG.starter.includedAiReplies,
    growth: PLAN_CATALOG.growth.includedAiReplies,
    scale: PLAN_CATALOG.scale.includedAiReplies,
    pro: PLAN_CATALOG.scale.includedAiReplies,
    enterprise: 1000000,
};
// LLM chat model routing — same model for every paid plan.
export const PLAN_MODELS = {
    starter: 'deepseek/deepseek-v4-flash',
    growth: 'deepseek/deepseek-v4-flash',
    scale: 'deepseek/deepseek-v4-flash',
    pro: 'deepseek/deepseek-v4-flash',
    enterprise: 'deepseek/deepseek-v4-flash',
};
export const FALLBACK_MODEL = 'deepseek/deepseek-v4-flash';
export const EMBEDDING_MODEL = 'nvidia/llama-nemotron-embed-vl-1b-v2:free';
export const EMBEDDING_DIMENSIONS = 2048;
export const SUPPORTED_CURRENCIES = [
    'USD',
    'GBP',
    'EUR',
    'NGN',
    'GHS',
    'KES',
    'ZAR',
];
export const DEFAULT_PAYMENT_PROVIDER = 'stripe';
export const COUNTRY_PAYMENT_PROVIDER = {
    NG: 'paystack',
    GH: 'paystack',
    KE: 'paystack',
    ZA: 'paystack',
    CI: 'flutterwave',
    UG: 'flutterwave',
    TZ: 'flutterwave',
    RW: 'flutterwave',
    US: 'stripe',
    GB: 'stripe',
    CA: 'stripe',
    AU: 'stripe',
    DE: 'stripe',
    FR: 'stripe',
    IE: 'stripe',
    NL: 'stripe',
    ES: 'stripe',
    IT: 'stripe',
};
export const CURRENCY_PAYMENT_PROVIDER = {
    NGN: 'paystack',
    GHS: 'paystack',
    KES: 'paystack',
    ZAR: 'paystack',
    USD: 'stripe',
    GBP: 'stripe',
    EUR: 'stripe',
};
export const SUPPORTED_COUNTRIES = [
    { code: 'NG', name: 'Nigeria', dialCode: '+234', currency: 'NGN' },
    { code: 'GH', name: 'Ghana', dialCode: '+233', currency: 'GHS' },
    { code: 'KE', name: 'Kenya', dialCode: '+254', currency: 'KES' },
    { code: 'ZA', name: 'South Africa', dialCode: '+27', currency: 'ZAR' },
    { code: 'US', name: 'United States', dialCode: '+1', currency: 'USD' },
    { code: 'GB', name: 'United Kingdom', dialCode: '+44', currency: 'GBP' },
    { code: 'CA', name: 'Canada', dialCode: '+1', currency: 'CAD' },
    { code: 'DE', name: 'Germany', dialCode: '+49', currency: 'EUR' },
    { code: 'FR', name: 'France', dialCode: '+33', currency: 'EUR' },
    { code: 'IE', name: 'Ireland', dialCode: '+353', currency: 'EUR' },
];
/** Deprecated fixed rate — use fee policy service instead. Kept for backward compat. */
export const PLATFORM_FEE_RATE = 0.05;
/** Expected PSSP processing rate for NGN transactions via Paystack (1.5% + ₦100 cap). */
export const DEFAULT_PSSP_RATE_NGN = 0.015;
export const DEFAULT_PSSP_FLAT_NGN = 100;
/** Minimum wallet balance (in the wallet's currency) required to request a payout. */
export const MIN_PAYOUT_AMOUNT = {
    NGN: 5000,
    GHS: 50,
    KES: 500,
    ZAR: 100,
    USD: 10,
    GBP: 10,
    EUR: 10,
};
export const DEFAULT_MIN_PAYOUT = 10;
export const DEFAULT_BRAND_COLORS = { primary: '#1A1A2E', accent: '#6C63FF' };
export const MAX_LINE_QUANTITY = 999;
export const DEFAULT_BILLING_CONFIG = {
    delivery: { enabled: false, flatFee: 0 },
    tax: { enabled: false, ratePercent: 0, label: 'Tax', inclusive: false },
    fees: [],
};
export const ACTION_REGEX = /ACTION:(CHECKOUT|SHOW_PRODUCT|ADD_TO_CART|BOOK|REQUEST_QUOTE|RESCHEDULE):([^\n]+)/g;
export const CONTACT_ACTION_REGEX = /ACTION:SAVE_CONTACT:(\{[^\n]*\})/g;
//# sourceMappingURL=constants.js.map